import { MULTITAB_SETPASO, MULTITAB_SETORIGEN, MULTITAB_LOGOUT } from "../../ActionTypes";

export const setPasoMultiTab = (paso) => (dispatch) => {
  dispatch({
    type: MULTITAB_SETPASO,
    payload: paso
  });
};

export const setOrigenMultitab = (origen) => (dispatch) => {
  dispatch({
    type: MULTITAB_SETORIGEN,
    payload: origen
  });
};

export const resetMultitab = () => (dispatch) => {
  dispatch({
    type: MULTITAB_LOGOUT,
  });
};
